const { redirectUri = "", clientId = "", authority = "", onPremise = false, } = (window?.runConfig || {});
export const shouldAuthenticate = () => !onPremise;
export const getAuthConfig = () => ({ clientId, authority, redirectUri });
